/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

class TaggerView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#tagger';

    this.prototype.events = {
      'click .choose-file': 'clickFileInput',
      'change .file-input': 'updateFileName',
      'change select': 'updateSkip',
    };
  }

  updateSkip(e) {
    const skip = JSON.parse($(e.currentTarget).val()).skip;
    if (skip) {
      return $(e.currentTarget).parents('tr').removeClass('danger').addClass('skip');
    } else {
      return $(e.currentTarget).parents('tr').addClass('danger').removeClass('skip');
    }
  }

  updateFileName(e) {
    return this.$el.find('.file-text-name').text($(e.currentTarget).val());
  }

  clickFileInput() {
    return this.$el.find('.file-input').click();
  }

  render() {
    return this;
  }
}
TaggerView.initClass();

export default TaggerView;
